import {
  GET_CHANGE_FORM_TYPE_DETAILS,
  GET_CHANGE_FORM_TYPE_DETAIL,
  POST_CHANGE_FORM_TYPE_DETAIL,
  PUT_CHANGE_FORM_TYPE_DETAIL,
  DELETE_CHANGE_FORM_TYPE_DETAIL
} from "../constants/actionTypes";

const defaultState = {
  changeFormTypeArr: [],
  changeFormTypeDetail: {}
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_CHANGE_FORM_TYPE_DETAILS:
      return { ...state, changeFormTypeArr: [...action.payload] };
    case GET_CHANGE_FORM_TYPE_DETAIL:
      return { ...state, changeFormTypeDetail: { ...action.payload } };
    case POST_CHANGE_FORM_TYPE_DETAIL:
      return { ...state, changeFormTypeArr: [...state.changeFormTypeArr, action.payload] };
    case PUT_CHANGE_FORM_TYPE_DETAIL:
      return {
        ...state,
        changeFormTypeArr: state.changeFormTypeArr.map((item) =>
          item.id === action.payload.id ? { ...action.payload } : item
        )
      };
    case DELETE_CHANGE_FORM_TYPE_DETAIL:
      return {
        ...state,
        changeFormTypeArr: state.changeFormTypeArr.filter((item) => item.id !== action.payload)
      };
    default:
      return state;
  }
};
